module.exports = "<!-- Header -->\n<app-header></app-header>\n\n<div class=\"content\">\n  <div class=\"banner\">\n    <div class=\"center-block\">\n      <h1>Learn better, together.</h1>\n      <div class=\"search\">\n        <button type=\"button\" class=\"btn\">Search</button>\n        <div class=\"search-icon\">\n          <img src=\"assets/images/icons/search-on-white.svg\" width=\"20\" alt=\"Search\" />\n        </div>\n        <input type=\"text\" placeholder='Try \"Painting a mural\"' />\n      </div>\n    </div>\n  </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.html
// module id = ./src/app/components/home/home.component.html
// module chunks = main